<form [formGroup]="rootForm" *ngIf="! currentControl.disabled">
  <div class="form-group form-row mx-1">
    <label [for]="idHtml" class="form-label">{{libelle$ | async }}</label>
    <div class="input-group">
      <div class="input-group-preprend" *ngIf="prefixe">
        <span class="input-group-text">{{prefixe}}</span>
      </div>
      <input [readOnly]="afficherEnLectureSeule" [max]="max" type="text" min="0" 
        [class]="'form-control ' + classeSupplInput" [class.is-warning]="aErreurCroiseeActive()"
        [class.is-invalid]="champInvalide()" [class.is-valid]="champValide()" [formControlName]="labelAffichage"
        [id]="idHtml">
    </div>

    <bis-affiche-erreurs class="col-12" *ngIf="erreursAffichable()" [erreurs]="rootForm.get(label).errors">
    </bis-affiche-erreurs>
  </div>
</form>